// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"db2db83c","177":"7c725adf","403":"5f3ccf06"}[chunkId] + ".chunk.css";
};